export default __webpack_public_path__ + "ebe3f43642af6dcfc563fa5010b61fc8.svg";